



























































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
const cityData = require("../../../assets/pca-code.json");
import MainHeader from "@/components/main-header.vue";
import ManageLeft from "@/components/manage-left.vue";
import { UploadFile, GetPaperDetail, PatchPaper } from "@/request/common";
import DsEditor from "@/components/ds-editor/ds-editor.vue";
@Component({
  components: {
    MainHeader,
    ManageLeft,
    DsEditor,
  },
})
export default class Name extends Vue {
  private yiyaoType: any = [
    "藏医药",
    "傣医药",
    "黎医药",
    "满医药",
    "蒙医药",
    "苗医药",
    "羌医药",
    "畲医药",
    "维吾尔医药",
    "瑶医药",
    "彝医药",
    "壮医药",
  ];
  private type: any = "";
  private data: any = {
    发文地区: [],
  };
  private citys: any = [
    "北京市",
    "天津市",
    "上海市",
    "重庆市",
    "河北省",
    "山西省",
    "辽宁省",
    "吉林省",
    "黑龙江省",
    "江苏省",
    "浙江省",
    "安徽省",
    "福建省",
    "江西省",
    "山东省",
    "河南省",
    "湖北省",
    "湖南省",
    "广东省",
    "海南省",
    "四川省",
    "贵州省",
    "云南省",
    "陕西省",
    "甘肃省",
    "青海省",
    "台湾省",
    "内蒙古自治区",
    "广西壮族自治区",
    "西藏自治区",
    "宁夏回族自治区",
    "新疆维吾尔自治区",
    "香港特别行政区",
    "澳门特别行政区",
  ];
  private cityOption: any;
  private get user() {
    return this.$store.state.user;
  }
  private forceUpdate() {
    this.$forceUpdate();
  }
  private previewFile() {
    if (this.data.file && this.data.file.length > 0) {
      window.open(this.data.file[0].url);
    } else {
      this.$message.warning("PDF文件缺失！");
    }
  }
  private preview() {
    window.open(this.data["封面"]);
  }
  private save() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = JSON.parse(JSON.stringify(this.data));
    params.author_address = this.data.author_address.split("、");
    params.keywords = this.data.keywords.split("、");
    PatchPaper(this, this.data.id, params).then((res: any) => {
      this.$message.success("保存成功！");
      this.$router.back();
    });
  }
  private upload(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "上传中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading).then((res: any) => {
      this.data.cover = res.data.file_url;
      this.$forceUpdate();
    });
  }
  private uploadVideo(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "上传中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading).then((res: any) => {
      this.data.file = [res.data];
      this.$forceUpdate();
    });
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetPaperDetail(this, this.data.id, loading)
      .then((res: any) => {
        loading.close();
        this.data = JSON.parse(JSON.stringify(res.data));
        this.data.author_address = res.data.author_address.join("、");
        this.data.keywords = res.data.keywords.join("、");
      })
      .catch(() => {
        loading.close();
      });
  }
  private mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.id) {
      this.data.id = this.$route.query.id;
      this.getData();
    }
  }
  /**
   * @description 加载三级联动数据，加载缓存的验证码等待时间
   */
  private beforeMount() {
    this.cityOption = cityData;
  }
}
